import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const MESSAGE = 'Call audio and video are recorded.';

export default function RecordingDisclaimer() {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const element = document.createElement('div');
    element.className = 'recording-disclaimer';
    document.body.appendChild(element);
    setContainer(element);

    return () => {
      document.body.removeChild(element);
      setContainer(null);
    };
  }, []);

  if (!container) {
    return null;
  }

  return createPortal(MESSAGE, container);
}
